import { array, object } from "superstruct";

import CustomerAddressSchema from "./CustomerAddressSchema";

const CustomerAddressesResponseSchema = object({
    customerAddresses: array(CustomerAddressSchema),
});

export default CustomerAddressesResponseSchema;
